// Mock data constants for Fiscalización module

//Badge color helpers
export const normalizeStr = s =>
	(s || '').normalize('NFD').replace(/\p{Mn}/gu, '').toLowerCase();

export const getAuthorityStatusBadgeColor = label => {
	const l = normalizeStr(label);
	if (l.includes('no cumple')) return 'red';
	if (l.includes('parcialmente')) return 'yellow';
	if (l.includes('revision')) return 'blue';
	if (l.includes('cumple')) return 'green';
	if (l.includes('pendiente')) return 'gray';
	return 'gray';
};

export const getInspectionStatusBadgeColor = label => {
	const l = normalizeStr(label);
	if (l.includes('pendiente')) return 'yellow';
	if (l.includes('incumplimiento')) return 'red';
	// Estos estados los agregué suponiendo que más adelante se podrían agregar
	// estados de fiscalización; por ahora no están en el maestro de inspection_status.
	if (l.includes('cerrado') || l.includes('finalizado')) return 'green';
	if (l.includes('revision') || l.includes('resvision') || l.includes('proceso')) return 'blue';
	return 'gray';
};



